module.exports = __webpack_public_path__ + "static/img/medal-03.14bde38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medal-03.png
// module id = 5SyO
// module chunks = 1